import {
  clueGetPhone,
  taskGetPhone,
  userGetPhone,
  smsGetPhone,
  systemGetPhone,
  recordGetPhone,
  deliveryGetPhone,
  getClueStudentPhone,
  getClueLinkPhone,
  platformUserGetPhone,
  platformUserGetPhone2,
  getLivePhone,
  getDecryptByUser,
  getEmailByUser,
  getHighSeasClue,
  getReceiverPhone,
  selectPfUserBackUpPhone,
  deliveryDetailsGetPhone,
  getUserPhoneFormEdata,
  getUserPhoneFormEdata2
} from '@/api/phoneEncrypt'
import { getRefundJamFullPhoneById } from '@/api/business'

const userId = async row => {
  const obj = { userId: row.userId, moduleCode: row.moduleCode }
  return await getDecryptByUser({
    ...obj,
    type: 1
  })
}

const userIdEdata = async row => {
  const userId = row.uid
  return await getUserPhoneFormEdata({ userId })
}

const userIdEdata2 = async row => {
  const userId = row.uid
  return await getUserPhoneFormEdata2(userId)
}

const refundJam = async row => {
  const { data } = await getRefundJamFullPhoneById({ id: row.id })
  // 后端返回的数据直接是字符串形式（区号+手机号）
  if (typeof data === 'string') {
    return { data }
  }
  // 如果返回的是对象，则将区号和手机号拼装在一起
  if (data && data.phoneAreaCode && data.phone) {
    return {
      data: `+${data.phoneAreaCode} ${data.phone}`
    }
  }
  // 其他情况直接返回data
  return { data }
}
const deliveryEmail = async row => {
  return await deliveryDetailsGetPhone({
    ...row
  })
}
const orderNo = async row => {
  return await getReceiverPhone(row.orderNo, row.moduleCode)
}

const clue = async row => {
  return await clueGetPhone({ clueId: row.id, moduleCode: row.moduleCode })
}

const backupPhone = async row => {
  return await selectPfUserBackUpPhone(row)
}

const clueThread = async row => {
  return await getClueStudentPhone(row.id)
}

const clueLive = async row => {
  return await getLivePhone(row.id)
}
const clueLinkThread = async row => {
  return await getClueLinkPhone(row.id)
}

const crm = async row => {
  return await taskGetPhone(row.id)
}

const user = async row => {
  console.log(1111, row)
  return await userGetPhone({ userId: row.uid, ...row })
}

const platformUser = async row => {
  return await platformUserGetPhone(row.id)
}

const platformUser2 = async row => {
  const res = await platformUserGetPhone2(row)
  return {
    data: res.data.phone
  }
}
const platformUserId = async row => {
  return await platformUserGetPhone(row.platformUserId)
}
const system = async row => {
  return await systemGetPhone(row.uid)
}
const sms = async row => {
  return await smsGetPhone({ id: row.id })
}
const delivery = async row => {
  return await deliveryGetPhone(row.shiftId)
}

const email = async row => {
  return await getEmailByUser(row.id)
}

const record = async row => {
  const { data } = await recordGetPhone({ id: row.id })
  return {
    data: data[row.type]
  }
}
const highSeasClue = async row => {
  const { data } = await getHighSeasClue({
    clueId: row.id,
    moduleCode: row.moduleCode
  })
  return {
    data: data
  }
}

export default {
  clue,
  clueThread,
  clueLinkThread,
  crm,
  user,
  sms,
  system,
  record,
  delivery,
  platformUser,
  platformUserId,
  platformUser2,
  clueLive,
  userId,
  email,
  orderNo,
  highSeasClue,
  backupPhone,
  deliveryEmail,
  userIdEdata,
  userIdEdata2,
  refundJam
}
